import { Alert, AlertTitle } from '@mui/material';
import useAlert from './UsePopUpAlert';

const PopUpAlert = () => {
    const { alerts } = useAlert();

    if (alerts.size > 0) {
        const alertEles: React.ReactNode[] = []
        alerts.forEach((x, i) => {
            alertEles.push(
                <Alert
                    key={i}
                    severity={x.type}
                    onClick={x.onClick}
                    onClose={x.onClose ?
                        (e) => {
                            e.stopPropagation()
                            x.onClose!()
                        } : undefined}
                >
                    {x.body && <AlertTitle>{x.title}</AlertTitle>}
                    {x.body ? x.body : x.title}
                </Alert>
            )
        })

        return <div style={{ position: "fixed", zIndex: 100000, right: 20, bottom: 20, }}>
            {alertEles}
        </div>
    } else {
        return <></>
    }
};

export default PopUpAlert